import React, {Fragment} from "react";
import {Col, Form, Icon, Input, Row, Avatar} from "antd";
import {Image} from "@models/image";
import ImagePicker from "@components/custom/imagePicker";
import {createRequest, fetchItemRequest, updateRequest} from "@actions/user";
import {User} from "@models/user";
import {FormattedMessage} from "react-intl";
import {REGEX_PATTERNS} from "@constants/regex";
import withFormWrapper from "@hocs/withFormWrapper";
import UserRoleSelection from "@components/user-roles/UserRoleSelection";
import {SelectionMode} from "../../models";
import {roleMultiSelectionDefaultReturnValue} from "../user-roles/UserRoleSelection";

interface PropsFromState {
  loading: boolean;
  errors?: string;
  form: any;
  user?: User;
}

interface PropsFromDispatch {
  createRequest: typeof createRequest;
  updateRequest: typeof updateRequest;
  fetchItemRequest: typeof fetchItemRequest;
}

type UserFormAllProps = PropsFromState & PropsFromDispatch;

interface UserFormStateShape extends User {
  visible: boolean;
  avatar: Image | null;
  avatar_url: string;
  id: string;
  name: string;
  username: string;
  email: string;
  mobile: any;
}

class UserForm extends React.Component<UserFormAllProps, UserFormStateShape> {
  
  private roles = roleMultiSelectionDefaultReturnValue;
  
  constructor(props) {
    super(props);
    const {user} = props;
    this.state = {
      ...this.getStateFromProps(user)
    };
  }
  
  getStateFromProps = (user: User | null): object => {
    //TODO check just once and set default values instead of inline if for each property!
    const obj = user || {};
    
    return {
      visible: false,
      name: obj.name || "",
      username: obj.username || "",
      email: obj.email || "",
      mobile: obj.mobile || "",
      avatar_url: obj.avatar_url || "",
      id: obj.id,
      roles: obj.roles || []
    };
  };
  
  getValues = () => {
    let returnValues = null;
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        returnValues = {
          ...values,
          avatar_url: values.avatar_url
            ? values.avatar_url
            : this.state.avatar_url,
          is_active: true //TODO
        };
      }
    });
    
    return {
      payload: {
        ...returnValues,
        roles : this.roles
      },
      id: this.state.id
    };
  };
  
  setAvatarImage = (image: Image) => {
    this.setState({
      avatar: image,
      avatar_url: image.path
    });
  };
  
  onChangeRoles = (roles) => {
    this.roles = roles;
  };
  
  render() {
    const {getFieldDecorator} = this.props.form;
    return (
      <Form className={"user-form"}>
        <Row>
          <Col span={24}>
            <Form.Item className={`no-label`}>
              {getFieldDecorator("avatar_url", {})(<Input type={`hidden`}/>)}
              <div style={{textAlign: "center", width: "100%"}}>
                <ImagePicker
                  onSelectImage={this.setAvatarImage}
                  selectedImage={this.state.avatar_url}
                >
                  <Avatar size={64} src={this.state.avatar_url} icon="user">
                    <Icon type="camera"/>
                  </Avatar>
                </ImagePicker>
              </div>
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label={<FormattedMessage id="app.name" defaultMessage={`Name`}/>}
            >
              {getFieldDecorator("name", {
                initialValue: this.state.name,
                rules: [
                  {
                    whitespace: true,
                    required: true,
                    message: (
                      <FormattedMessage
                        id="app.name_is_required"
                        defaultMessage={`Name is required`}
                      />
                    )
                  }
                ]
              })(<Input/>)}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label={<FormattedMessage id="app.username" defaultMessage={`Name`}/>}>
              {getFieldDecorator("username", {
                initialValue: this.state.username,
                rules: [
                  {
                    whitespace: true,
                    required: true,
                    message: (
                      <FormattedMessage
                        id="app.username_is_required"
                        defaultMessage={`Username is required`}
                      />
                    )
                  }
                ]
              })(<Input disabled={this.state.id ? true : false}/>)}
            </Form.Item>
          </Col>
          
          {!this.state.id && (
            <Fragment>
              <Col span={8}>
                <Form.Item
                  label={
                    <FormattedMessage
                      id="app.password"
                      defaultMessage={`Password`}
                    />
                  }
                >
                  {getFieldDecorator("user_password", {
                    initialValue: this.state.user_password,
                    rules: [{
                        whitespace: true,
                        required: true,
                        message: (
                          <FormattedMessage
                            id="app.password_is_required"
                            defaultMessage={`Password is required`}
                          />
                        )
                      },
                      {
                        min: 8,
                        message: (
                          <FormattedMessage
                            id="app.min_length_password"
                            defaultMessage={`Password must be have at least 8 character`}
                          />
                        )
                      }
                    ]
                  })(<Input/>)}
                </Form.Item>
              </Col>
              < Col span={8}>
                <Form.Item
                  label={
                    <FormattedMessage
                      id="app.mobile"
                      defaultMessage={`Password`}
                    />
                  }
                >
                  {getFieldDecorator("mobile", {
                    initialValue: this.state.mobile,
                    rules: [{
                        whitespace: true,
                        required: true,
                        message: (
                          <FormattedMessage
                            id="app.mobile_is_required"
                            defaultMessage={`Mobile is required`}
                          />
                        )
                      },
                      {
                        pattern: REGEX_PATTERNS.MOBILE,
                        message: (
                          <FormattedMessage
                            id="app.value_is_not_valid"
                            defaultMessage={`The value is not valid!`}
                          />
                        )
                      }
                    ]
                  })(<Input placeholder={"989121111111"}/>)}
                </Form.Item>
              </Col>
            </Fragment>
          )}
          <Col span={8}>
            <Form.Item
              label={
                <FormattedMessage id="app.email" defaultMessage={`Email`}/>
              }
            >
              {getFieldDecorator("email", {
                initialValue: this.state.email,
                rules: [
                  {
                    type: "email",
                    message: (
                      <FormattedMessage
                        id="app.value_is_not_valid"
                        defaultMessage={`The value is not valid!`}
                      />
                    )
                  }
                ]
              })(<Input/>)}
            </Form.Item>
          </Col>
  
          <Col span={24}>
            <Form.Item label={<FormattedMessage id="app.user_roles" defaultMessage={`Roles`}/>}>
              {getFieldDecorator("roles", {
                // initialValue: this.state.roles.join(","),
              })(<Input type={"hidden"}/>)}
            </Form.Item>
            <UserRoleSelection
              mode={SelectionMode.MULTIPLE}
              onChange={this.onChangeRoles}
              initialValue={this.state.roles || []}
            />
          </Col>
          
        </Row>
      </Form>
    );
  }
}

const WrappedUserForm = Form.create({name: "user-form"})(UserForm);

export default withFormWrapper(WrappedUserForm);
